import PRICE_FORMAT from './PriceFormat';

export default {
  APP_DATASET_NAME: '$app',
  COMM_DISENGAGE_DATASET_NAME: '$disengage',
  THEME_DATASET_NAME: '$theme',
  ROOT_BOX_CONFIG_DATASET_NAME: '$box',
  MAX_DISHES: 24,
  DEFAULT_DISH_INDEX: 1,
  DATASET_REAL_NAME_KEY: '$dataset_name',
  DEFAULT_SIZE_FACTOR: 1,
  DEFAULT_PRICE_FORMAT: PRICE_FORMAT.EURO,
  BACKDOOR_EVENT_NAME: 'bAckDoor',
  DISENGAGE_COMM_END_EVENT_NAME: 'disengage_comm_end',
  DISHES_ROTATION_EVENT_NAME: 'dishes_rotation',
  ENV: {
    DEVELOPMENT: 'development',
    STAGING: 'staging',
    PRODUCTION: 'production',
  },
  ROTATE: {
    PORTRAIT: 'portrait',
    PORTRAIT_REVERSE: 'portrait-reverse',
    LANDSCAPE_REVERSE: 'landscape-reverse',
  },
};
